import { createSelector } from '@reduxjs/toolkit';
import selfSelector from './self';

const loadingSelector = createSelector(selfSelector, (trackerStats) => trackerStats.loading);

export default loadingSelector;
